
class BackInStock extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('[data-bis-email]');
    this.button = this.querySelector('[data-bis-submit]');
    this.status = this.querySelector('[data-bis-status]');
    if (!this.input || !this.button) return;

    this.button.addEventListener('click', () => this.send());
    this.input.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') { e.preventDefault(); this.send(); }
    });
  }

  async send() {
    const endpoint = (this.dataset.endpoint || '').replace(/\/$/, '');
    const email = this.input.value.trim();
    if (!endpoint || !this.input.checkValidity() || !email) {
      this.input.reportValidity();
      return;
    }

    this.button.disabled = true;
    this.say('', null);
    try {
      const res = await fetch(`${endpoint}/public/back-in-stock`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email,
          productId: this.dataset.productId,
          locale: this.dataset.locale,
        }),
      });
      const out = await res.json();
      if (!out.ok) throw new Error(out.error || '');
      this.input.value = '';
      this.say(window.themeStrings?.bisThanks, 'ok');
    } catch (e) {
      this.say(e.message || window.themeStrings?.bisError, 'err');
    } finally {
      this.button.disabled = false;
    }
  }

  say(text, kind) {
    if (!this.status) return;
    this.status.textContent = text || '';
    this.status.className = `bis__status${kind ? ` is-${kind}` : ''}`;
    this.status.hidden = !text;
  }
}

customElements.define('back-in-stock', BackInStock);
